import { type Role, type TransformedRole } from './types'

export const transformRoles = (roles: Role[]): TransformedRole[] =>
  roles.map((role: Role) => ({
    title: `${role.roleName} (${role.roleType})`,
    value: role.roleName
  }))
